export const extractPromptErrorMessage = (error: any): string =>
  error?.data?.error || error?.data?.message || error?.message || 'Request failed';

export const requiresStaleCaseAcknowledgment = (error: any): boolean =>
  extractPromptErrorMessage(error).includes('acknowledge_stale_cases');

export const staleCaseAcknowledgmentMessage =
  'This publish has stale eval cases. Continue and acknowledge stale cases for this publish?';

export async function withStaleCaseAcknowledgmentRetry<
  TRequest extends { acknowledge_stale_cases?: boolean },
  TResult,
>(request: TRequest, execute: (payload: TRequest) => Promise<TResult>): Promise<TResult> {
  try {
    return await execute(request);
  } catch (error: any) {
    if (!requiresStaleCaseAcknowledgment(error)) {
      throw error;
    }
    const confirmed = window.confirm(staleCaseAcknowledgmentMessage);
    if (!confirmed) {
      throw error;
    }

    return execute({ ...request, acknowledge_stale_cases: true });
  }
}
